import styled from "styled-components"

import {TagCss} from "@irati/ui/src/Tag/styled"
import RouterLink from "@irati/ui/src/Link/RouterLink"

export default styled(RouterLink)`
  ${TagCss}
  &:hover {
    text-decoration: none;
    color: #000000;
  }
`
